export default {
      id: "done-rounded-circle-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#done-rounded-circle",
      toString: function () {
        return this.url;
      }
    }